export const getInitialDeliveryOption = (deliveryOptions) => {
    return deliveryOptions.find((option) => option.defaultDelivery) ?? deliveryOptions[0];
};
//# sourceMappingURL=getInitialDeliveryOption.js.map